module.exports = __webpack_public_path__ + "static/media/truck_back_1.9b2eb1a6.png";